import * as yup from "yup";
import { emailRegex } from "../../utilities/regex";

export const profileEmailSchema = yup
  .object({
    email: yup.string().email().matches(emailRegex).required(),
  })
  .required();

export const profileSchema = yup
  .object({
    firstName: yup.string().nullable(),
    lastName: yup.string().nullable(),
    phoneNumber: yup
      .object({
        countryCode: yup.string(),
        number: yup.string().label("Phone number"),
        country: yup.string(),
      })
      .nullable(),
    jobTitle: yup.string().nullable(),
    country: yup.string().nullable(),
  })
  .required();
